import { v1 } from "../api";

export async function getDenominacionesSociales() {
  const response = await v1.get("resources/denominaciones-sociales");

  return response.data;
}

export async function getRepresentacionesGeograficas() {
  const response = await v1.get("resources/representaciones-geograficas");

  return response.data;
}

export async function getCamarasDeComercio() {
  const response = await v1.get("resources/camaras-de-comercio");

  return response.data;
}

export async function getDepartamentosDeHonduras() {
  const response = await v1.get("resources/departamentos-de-honduras");

  return response.data;
}

export async function getCiudades() {
  const response = await v1.get("resources/ciudades");

  return response.data;
}

export async function getDecretosLegislativos() {
  const response = await v1.get("resources/decretos-legislativos");

  return response.data;
}

export async function getActividadesEconomicas() {
  const response = await v1.get("resources/actividades-economicas");

  return response.data;
}

export async function getClasesPorGrupo() {
  const response = await v1.get("resources/clases-por-grupo");

  return response.data;
}

export async function getGeneros() {
  const response = await v1.get("resources/generos");

  return response.data;
}

export async function getCargos() {
  const response = await v1.get("resources/cargos");

  return response.data;
}

export async function getFormasDePago() {
  const response = await v1.get("resources/formas-de-pago");

  return response.data;
}

export async function getFrecuenciasDePago() {
  const response = await v1.get("resources/frecuencias-de-pago");

  return response.data;
}
